import { createContext } from 'react'

export const context = createContext<((time: number) => void) | null>(null)
